module.exports = __webpack_public_path__ + "static/media/bgContactSM.fa6927d4.jpg";